import React from 'react';

const Offer = () => {
  return (
    <section id='offer'>
      <div className='container tc'>
        <div className='s-48'></div>
        <h3 className='title-sub'>Програма навчання</h3>
        <div className='s-32'></div>
        <h4 className='title-mini w-60 ma'>
          Курси вайб-кодінгу складаються з трьох модулів:
        </h4>
        <div className='s-48'></div>
        <div className='row'>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>💼</p>
              <h3 className='title-card'>Розробка портфоліо</h3>
              <ul className='c-list'>
                <li>Кейси</li>
                <li>Підряди</li>
                <li>Клієнти</li>
              </ul>
              <a href='/ua' className='button pink'>
                Детальніше
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>👨‍💻</p>
              <h3 className='title-card'>Створення IT-Продукту</h3>
              <ul className='c-list'>
                <li>Генерація коду</li>
                <li>Відлагодження помилок</li>
                <li>Допомога менторів</li>
              </ul>
              <a href='/ua' className='button pink'>
                Детальніше
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='col-lg-4'>
            <div className='c-card'>
              <p className='title-icon'>🎬</p>
              <h3 className='title-card'>PR персонального бренду в ЗМІ</h3>
              <ul className='c-list'>
                <li>Піар і Новини</li>
                <li>Соціальні мережі</li>
                <li>Ділові партнерства</li>
              </ul>
              <a href='/ua' className='button pink'>
                Детальніше
              </a>
              <div className='s-24'></div>
            </div>
          </div>
          <div className='s-48'></div>
        </div>
      </div>
    </section>
  );
};

export { Offer }; 